import { Chip } from "@mui/material";
import {
  CallMissedOutgoingOutlinedIcon,
  LegendToggleIcon,
  AttachMoneyIcon,
  FileCopyIcon,
} from "src/Pages/components/Icons/Icons";
import {
  getLogEntityIcon,
  normalizeCategory,
} from "src/Pages/components/CategoryEntityIconMap";

export const handleChipCoreCategories = (type: string | null) => {
  if (!type) {
    return <Chip color="default" label="-" size="small" variant="outlined" />;
  }

  const normalizedType = normalizeCategory(type);

  switch (type.toUpperCase()) {
    case "SALDO_INICIAL":
      return (
        <Chip
          color="info"
          icon={<CallMissedOutgoingOutlinedIcon sx={{ paddingLeft: "2px" }} />}
          label="Saldo inicial"
          size="small"
          sx={{
            maxWidth: "120px",
            display: "flex",
            justifyContent: "left",
            paddingTop: "2px",
          }}
          variant="outlined"
        />
      );
    case "LANCAMENTO":
      return (
        <Chip
          color="success"
          icon={<AttachMoneyIcon />}
          label="Lançamento"
          size="small"
          sx={{
            maxWidth: "120px",
            display: "flex",
            justifyContent: "left",
            paddingTop: "2px",
          }}
          variant="outlined"
        />
      );
    case "LISTAGEM":
      return (
        <Chip
          color="warning"
          icon={<FileCopyIcon sx={{ paddingLeft: "3px", width: "16px" }} />}
          label="Listagem"
          size="small"
          sx={{
            maxWidth: "120px",
            display: "flex",
            justifyContent: "left",
            paddingTop: "2px",
          }}
          variant="outlined"
        />
      );

    case "COMISSAO_ESPECIAL":
      return (
        <Chip
          color="warning"
          icon={<LegendToggleIcon sx={{ paddingLeft: "3px", width: "24px" }} />}
          label="ESPECIAL"
          size="small"
          sx={{
            maxWidth: "125px",
            display: "flex",
            justifyContent: "left",
            paddingTop: "2px",
          }}
          variant="outlined"
        />
      );
    case "SALAO":
      return (
        <Chip
          color="info"
          label="SALÃO"
          size="small"
          sx={{
            maxWidth: "120px",
            display: "flex",
            justifyContent: "center",
            paddingTop: "2px",
          }}
        />
      );
    case "REPASSE":
      return (
        <Chip
          label="REPASSE"
          size="small"
          sx={{
            color: "#06cb13",
            maxWidth: "125px",
            display: "flex",
            justifyContent: "center",
            paddingTop: "2px",
            borderColor: "#06cb13",
          }}
          variant="outlined"
        />
      );
    case "FREE LANCE":
      return (
        <Chip
          label="FREE LANCE"
          size="small"
          sx={{
            color: "#cbb406",
            maxWidth: "125px",
            display: "flex",
            justifyContent: "center",
            paddingTop: "2px",
            borderColor: "#cbb406",
          }}
          variant="outlined"
        />
      );
    case "CONECTOR":
      return (
        <Chip
          label="CONECTOR"
          size="small"
          sx={{
            color: "#16cb06",
            maxWidth: "125px",
            display: "flex",
            justifyContent: "center",
            paddingTop: "2px",
            borderColor: "#16cb06",
          }}
          variant="outlined"
        />
      );
    case "ADMINISTRATIVO":
      return (
        <Chip
          label="ADMINISTRATIVO"
          size="small"
          sx={{
            color: "#0676cb",
            maxWidth: "125px",
            display: "flex",
            justifyContent: "center",
            paddingTop: "2px",
            borderColor: "#0676cb",
          }}
          variant="outlined"
        />
      );

    default: {
      const logEntityIcon = getLogEntityIcon(normalizedType);

      if (logEntityIcon) {
        return (
          <Chip
            icon={logEntityIcon}
            label={type}
            size="small"
            variant="outlined"
            sx={{
              backgroundColor: "#F2F2F2",
              color: "#505050",
              borderColor: "#CFCFCF",
              "& .MuiChip-icon": {
                color: "#707070",
              },
            }}
          />
        );
      }

      return (
        <Chip
          color="default"
          label={type}
          size="small"
          sx={{ backgroundColor: "#E7E7E7" }}
          variant="outlined"
        />
      );
    }
  }
};
